//Yup and Formik are used for validations
import * as yup from "yup";

export const PhoneNumberValidationSchema = yup.object({
  phoneNumber: yup.string().min(10).max(10).required("Phone number is required."),
});
